import { render, staticRenderFns } from "./authManage.vue?vue&type=template&id=57764326&scoped=true&"
import script from "./authManage.vue?vue&type=script&lang=js&"
export * from "./authManage.vue?vue&type=script&lang=js&"
import style0 from "./authManage.vue?vue&type=style&index=0&id=57764326&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57764326",
  null
  
)

export default component.exports